import {Action} from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { CallUserConfigModel } from '@smarttask-common/src/lib/models/CRM/Call/CallUserConfigModel';

export enum CallUserConfigActionTypes {
  ADD_CALLUSERCONFIG = '[CallUserConfig] Create CallUserConfig',
  UPSERT_CALLUSERCONFIG = '[CallUserConfig] Upsert CallUserConfig',
  ADD_CALLUSERCONFIGS = '[CallUserConfig] Add CallUserConfigs',
  UPSERT_CALLUSERCONFIGS = '[CallUserConfig] Upsert CallUserConfigs',
  UPDATE_CALLUSERCONFIG = '[CallUserConfig] Update CallUserConfig',
  UPDATE_CALLUSERCONFIGS = '[CallUserConfig] Update CallUserConfigs',
  DELETE_CALLUSERCONFIG = '[CallUserConfig] Delete CallUserConfig',
  DELETE_CALLUSERCONFIGS = '[CallUserConfig] Delete CallUserConfigs',
  DELETE_STATE = '[CallUserConfig] Delete State',

  UPDATE_SELECTED_ID = '[CallUserConfig] Update SelectedId'
}

export class UpdateSelectedCallUserConfigId implements Action{
  readonly type = CallUserConfigActionTypes.UPDATE_SELECTED_ID;
  constructor(public selected_config_id: number){}
}

export class AddOne implements Action{
  readonly type = CallUserConfigActionTypes.ADD_CALLUSERCONFIG;
  constructor(public callUserConfig: CallUserConfigModel){

  }
}

export class AddMany implements Action{
  readonly type = CallUserConfigActionTypes.ADD_CALLUSERCONFIGS;
  constructor(public callUserConfigs: Array<CallUserConfigModel>){

  }
}

export class UpsertOne implements Action {
  readonly type = CallUserConfigActionTypes.UPSERT_CALLUSERCONFIG;

  constructor(
    public callUserConfig: CallUserConfigModel) {}
}

export class UpsertMany implements Action {
  readonly type = CallUserConfigActionTypes.UPSERT_CALLUSERCONFIGS;
  constructor(public callUserConfigs: Array<CallUserConfigModel> ) {}
}

export class UpdateOne implements Action{
  readonly type = CallUserConfigActionTypes.UPDATE_CALLUSERCONFIG;
  constructor(
    public id: number, 
    public changes: Partial<CallUserConfigModel>
  ){
    
  }
}
export class UpdateMany implements Action{
  readonly type = CallUserConfigActionTypes.UPDATE_CALLUSERCONFIGS;
  constructor(
    public updates: Array<Update<CallUserConfigModel>>
  ){
    
  }
}

export class DeleteOne implements Action{
  readonly type = CallUserConfigActionTypes.DELETE_CALLUSERCONFIG;
  constructor(
    public id: number
  ){}
}

export class DeleteMany implements Action{
  readonly type = CallUserConfigActionTypes.DELETE_CALLUSERCONFIGS;
  constructor(
    public ids: Array<number>
  ){}
}

export class DeleteState implements Action{
  readonly type = CallUserConfigActionTypes.DELETE_STATE;
  constructor(){}
}

export type CallUserConfiglistActions = 
  AddOne 
  | AddMany 
  | UpsertOne 
  | UpsertMany 
  | DeleteOne 
  | DeleteMany 
  | DeleteState
  | UpdateOne
  | UpdateMany
  | UpdateSelectedCallUserConfigId;